import React from 'react';
import ProductRow from './ProductRow';

const CategoryRow = ({
  category,
  products,
  locationsBySelectedRegion,
  expandedProducts,
  toggleProductExpansion,
  toggleCategoryExpansion,
  findSKUStatus,
  tableData,
  expandedRegions,
  pendingData,
  pendingDataUS,
  pendingDataUK,
  getLocationDisplayName,
}) => {
  return (
    <React.Fragment>
      <tr className="bg-slate-800 text-white">
        <td
          className="px-3 py-3 sticky left-0 bg-slate-800 border-r min-w-[200px] max-w-[250px] cursor-pointer hover:bg-slate-700"
          onClick={() => toggleCategoryExpansion(category)}>
          <div className="flex items-center gap-2">
            <span className="font-bold text-white truncate" title={category}>
              {category}
            </span>
          </div>
        </td>
        {Object.entries(locationsBySelectedRegion).map(([region, locations]) => (
          <React.Fragment key={region}>
            <td className="px-3 py-3 border-r"></td>
            {expandedRegions[region] && (
              <>
                <td className="px-3 py-3 border-r"></td>
                <td className="px-3 py-3 border-r"></td>
                <td className="px-3 py-3 border-r"></td>
                {locations.map((location) => (
                  <td key={location} className="px-3 py-3 border-r"></td>
                ))}
              </>
            )}
          </React.Fragment>
        ))}
      </tr>
      {products.map((product, index) => (
        <ProductRow
          key={`${product.productName}-${index}`}
          product={product}
          locationsBySelectedRegion={locationsBySelectedRegion}
          expandedProducts={expandedProducts}
          toggleProductExpansion={toggleProductExpansion}
          findSKUStatus={findSKUStatus}
          tableData={tableData}
          expandedRegions={expandedRegions}
          pendingData={pendingData}
          pendingDataUS={pendingDataUS}
          pendingDataUK={pendingDataUK}
          getLocationDisplayName={getLocationDisplayName}
        />
      ))}
    </React.Fragment>
  );
};

export default React.memo(CategoryRow);
